
// 상품 상세에서 리뷰 별점 클릭시, 리뷰영역 오픈
function trigger_review_open() {
    //alert('review open!!!');

    var btn_review =document.getElementById('btn-product-review-layer'); // 변수에 엘리먼트 저장

    if(! btn_review.classList.contains('is-open')) {
      btn_review.click();
    }
  
  	dbl_open_review();  

}

function dbl_open_review() {
  
  	var btn_review =document.getElementById('btn-product-review-layer'); // 변수에 엘리먼트 저장
  
    /* 리뷰 쓰기 버튼 */
    var elements = document.getElementsByClassName("write-review-button");
    for (var i = 0; i < elements.length; i++) {
      if(i < 1) {
        //elements[i].click();
        rbtn = elements[i];
        rbtn.click();

        setTimeout(function() {
          btn_review.click();
        }, 1000);
        setTimeout(function() {
          btn_review.click();
        }, 1000);        
      }
    }
}





document.addEventListener("DOMContentLoaded", function(){
  
	// Handler when the DOM is fully loaded

  	// dbl_open_review();

	//const btns = document.querySelectorAll('dl.opn-toggle-wrapper > dt');
  	const btns = document.querySelectorAll('.opn-btn-toggle');
  
	btns.forEach(el => el.addEventListener('click', event => {
      
      //reset_faq_list();
      
      /* 
      var target =  event.target;
      alert(target.className);
      
      var toggle_wrap =  event.target.parentNode;
      alert(toggle_wrap.className);
      */
      
      var toggle_ctnt =  event.target.nextElementSibling;
      if (toggle_ctnt.classList.contains('hide')) {
        reset_faq_list();
        toggle_ctnt.classList.remove('hide');
      }
      else {
        toggle_ctnt.classList.add('hide');
      }

	}));
  
  
    function reset_faq_list() {
      //
      var els = document.querySelectorAll(".opn-toggle-wrap dd");
      els.forEach(function(el) {
        el.classList.add('hide');
      });
    }
  
  
  // 팝업 자동 오픈
  //var popup = win_open('pages/popup-1', 'popup', 'left=600px,top=0px,width=455px,height=800px,scrollbars=0');
  
});















